var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9494_16565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7639 29.3762L21.1267 11.8076L19.9727 7.17578L27.6756 7.99124V29.2433L22.9702 31.959L21.7639 29.3762Z",
    fill: "#24386C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6752 7.98917L22.9697 10.7067L13.2594 8.57672L1.89362 13.2044L0 7.98917L6.91766 3.99458L13.8374 0L20.7553 3.99458L27.6752 7.98917Z",
    fill: "#7589BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.98849L4.70543 10.7061L7.43307 18.8181L16.6428 26.187L13.8376 31.956L6.91786 27.9612L0 23.9666V7.98828",
    fill: "#B2BFE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9574 21.9258L13.8379 26.5247V31.9577L18.2644 29.4037L20.5452 25.9979",
    fill: "#24386C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8405 21.0916L9.41211 13.4243L10.366 10.8831L13.9921 9.125L18.2652 13.4245L13.8405 21.0916Z",
    fill: "#7589BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41144 13.4258L13.838 15.9798V21.092L9.74401 21.2682L7.26758 18.1061L9.41144 13.4258",
    fill: "#B2BFE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8379 15.9796L18.2644 13.4258L21.277 18.442L17.6314 21.4542L13.8379 21.092V15.9796Z",
    fill: "#24386C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2636 29.4009L22.969 31.9551V10.7052L18.402 8.06939L13.8371 5.43359L9.27002 8.06939L4.70508 10.7052V21.2503L9.27002 23.8861L13.8371 26.5221L18.2636 23.9657V29.4009ZM18.2636 18.5327L13.8371 21.0888L9.41051 18.5327V13.4226L13.8371 10.8664L18.2636 13.4226V18.5327Z",
    fill: "#DC244C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.839 26.5268V21.0929L9.43555 18.5586V23.9835L13.839 26.5268Z",
    fill: "url(#paint0_linear_9494_16565)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9494_16565",
    x1: 368.592,
    y1: 375.869,
    x2: -70.2045,
    y2: 375.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C91540",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9494_16565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.6757,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo27);
export default __webpack_public_path__ + "static/media/logo27.3e5c211b21135188d7c013750dfaa864.svg";
export { ForwardRef as ReactComponent };